import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSettings, FiPlus } = FiIcons;

const BoardSelector = ({ boards, currentBoardId, onBoardSwitch, onBoardManagerOpen }) => {
  const boardList = Object.values(boards);

  return (
    <div className="bg-white border-b border-gray-200">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center space-x-4 overflow-x-auto">
          <span className="text-sm font-medium text-gray-600 whitespace-nowrap">Boards:</span>
          
          <div className="flex items-center space-x-2">
            {boardList.map((board) => (
              <motion.button
                key={board.id}
                onClick={() => onBoardSwitch(board.id)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  currentBoardId === board.id
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                {board.name}
              </motion.button>
            ))}
          </div>

          <motion.button
            onClick={onBoardManagerOpen}
            className="ml-auto p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <SafeIcon icon={FiSettings} className="w-5 h-5" />
          </motion.button>
        </div>
      </div>
    </div>
  );
};

export default BoardSelector;